const state = {
    notifications:[],
};

const getters = {
    notifications: state => state.notifications,
    count: state => state.notifications.length,
};

const actions = {
    getUnread(context) {
        axios.post('/notifications/get-unread/')
            .then(function(response) {
                context.commit('updateNotifications', response.data);
                context.dispatch('updateWindowTitle');
            });
    },
    clear(context, notification) {
        axios.post('/notifications/remove/', { id: notification.id })
            .then(function(response) {
                context.commit('removeNotification', response.data);
                context.dispatch('updateWindowTitle');
            });
    },
    clearAll(context) {
        axios.post('/notifications/removeAll/')
            .then(function(response) {
                context.commit('removeAllNotifications');
                context.dispatch('updateWindowTitle');
            });
    },

    updateWindowTitle(context) {
        if (context.state.notifications.length > 0) {
            window.document.title = window.InitialTitle + " (" + context.state.notifications.length + ")";
        }
        else {
            window.document.title = window.InitialTitle;
        }
    }
};

const mutations = {
    updateNotifications: (state, data) => {
        state.notifications = data;
    },
    removeAllNotifications: (state) => {
        state.notifications = [];
    },
    removeNotification: (state, id) => {
        state.notifications = state.notifications.filter(function (item) {
            return item.id !== id;
        });
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};
